import { lazy, useEffect, useState } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { BackBtn, Loader, NVButton } from '@nv/basic-components'
import { ConfirmUnlockAdmin, useNVModal } from '@nv/components'
import { useConfigurationContext } from '@nv/contexts'
import { AdminVoterService } from '@nv/services'
import { formatDateLocale } from '@nv/utils'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { RegistartionDetails } from './components/RegistrationDetails'
import styles from './AdminEligibleDetails.module.scss'
const RemoveEligibleElector = lazy(() => import('@nv/lazy-loadable/lib/modals/RemoveEligibleElector'))
const StrikeOffVoter = lazy(() => import('@nv/lazy-loadable/lib/modals/StrikeOffVoter'))
const ReverseStrikeOffVoter = lazy(() => import('@nv/lazy-loadable/lib/modals/ReverseStrikeOffVoter'))
const NVBasicModal = lazy(() => import('@nv/lazy-loadable/lib/modals/NVBasicModal'))
const EditUser = lazy(() => import('@nv/lazy-loadable/lib/modals/EditUser'))
const Note = lazy(() => import('@nv/lazy-loadable/lib/modals/Note'))

// TODO VBM translations
export const AdminEligibleDetails = () => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const { voterId } = useParams()
  const [user, setUser] = useState(null)
  const { displayStrikeOffOnlyVotingChannels, adminRolesPerAction, strikeOffButtonEnabled, includeKnownIdNumber } =
    useConfigurationContext()
  const { NVModal: ConfirmUnlockAdminModal, openModal: openConfirmUnlockAdminModal } = useNVModal()
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const prevPage = atob(searchParams.get('pageState'))
  const [editUserModalView, setEditUserModalView] = useState('Edit')
  const [updateBallotStatusModalText, setUpdateBallotStatusModalText] = useState('')
  const [updateBallotStatus, setUpdateBallotStatus] = useState('')
  const [downloading, setDownloading] = useState(false)
  const [displayedVotingChannelStrikeOff, setDisplayedVotingChannelStrikeOff] = useState(user?.votingChannel || 'inPerson')

  const {
    NVModal: RemoveEligibleElectorModal,
    openModal: openRemoveEligibleElectorModal,
    closeModal: closeRemoveEligibleElectorModal,
  } = useNVModal()
  const { NVModal: RemoveEligibleElectorFailedModal, openModal: openRemoveEligibleElectorFailedModal } = useNVModal()
  const { NVModal: EditUserModal, openModal: openEditUserModal } = useNVModal()
  const { NVModal: StrikeOffVoterModal, openModal: openStrikeOffVoterModal, closeModal: closeStrikeOffVoterModal } = useNVModal()
  const { NVModal: StrikeOffFailedModal, openModal: openStrikeOffFailedModal } = useNVModal()
  const {
    NVModal: ReverseStrikeOffVoterModal,
    openModal: openReverseStrikeOffVoterModal,
    closeModal: closeReverseStrikeOffVoterModal,
  } = useNVModal()
  const { NVModal: ReverseStrikeOffFailedModal, openModal: openReverseStrikeOffFailedModal } = useNVModal()
  const {
    NVModal: UpdateBallotStatusModal,
    openModal: openUpdateBallotStatusModal,
    closeModal: closeUpdateBallotStatusModal,
  } = useNVModal()
  const { NVModal: NoteModal, openModal: openNoteModal, closeModal: closeNoteModal } = useNVModal()

  useEffect(() => {
    if (voterId) getUser()
  }, [voterId])

  const getUser = async () => {
    setLoading(true)
    const resp = await AdminVoterService.getEligible(voterId)

    if (resp) {
      setUser(resp.result)
    }
    setLoading(false)
  }
  const getStatus = (info) => {
    if (info.removed) return 'removed'
    else if (info.voted) return 'voted'
    else if (info.registered) return 'registered'

    return 'registered'
  }

  const handleRemoveEligibleElector = async (reason) => {
    const result = await AdminVoterService.removeEligible(voterId, { reason })
    if (result.success) {
      getUser()
      closeRemoveEligibleElectorModal()
    } else {
      openRemoveEligibleElectorFailedModal()
    }
  }

  // TODO: adjust based on whether strike off all districts at a time or one at a time PENDING CLIENT FEEDBACK
  const handleStrikeOffEligibleElector = async ({ votingChannel, votingDistrict }) => {
    setLoading(true)
    const result = await AdminVoterService.strikeOffEligible(user.electorId, { votingChannel, district: votingDistrict })

    if (result.success) {
      getUser()
      setLoading(false)
      closeStrikeOffVoterModal()
    } else {
      openStrikeOffFailedModal()
    }
    setLoading(false)
  }

  const handleReverseStrikeOffEligibleElector = async ({ votingDistrict }) => {
    const result = await AdminVoterService.reverseStrikeOffEligible(user.electorId, { district: votingDistrict })
    if (result.success) {
      getUser()
      closeReverseStrikeOffVoterModal()
    } else {
      openReverseStrikeOffFailedModal()
    }
  }

  const getDowloadUrlVBMPacakge = async () => {
    setDownloading(true)
    const res = await AdminVoterService.getVoteByMailPackageVoter(user.id)
    if (res?.success) {
      const href = URL.createObjectURL(res.data)
      // setDownloadURL(href)
      const link = document.createElement('a')
      link.download = `vbm-${user.fullName}`
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else {
      alert('An error occurred')
    }
    setDownloading(false)
  }

  const handleUpdateMailBallotStatus = async (status) => {
    if (status === 'Printed') {
      getDowloadUrlVBMPacakge()
    }
    setUpdateBallotStatus(status)
    setUpdateBallotStatusModalText(`Please confirm you would like to mark this ballot as ${status}`)
    openUpdateBallotStatusModal()
    // if (window.confirm(`Please confirm you would like to mark this ballot as ${status}`)) {

    // }
  }
  const onClickOkUpdateBallot = async () => {
    const result = await AdminVoterService.updateVoteByMailBallotStatus(user._id, { mailBallotStatus: updateBallotStatus })
    if (result.success) {
      closeUpdateBallotStatusModal()
      getUser()
    } else {
      alert('An error occurred.')
    }
  }

  // TODO: modal to edit and save notes
  // display existing notes and append/edit
  const updateNotes = async (notes) => {
    closeNoteModal()
    const result = await AdminVoterService.updateNotes(user._id, { notes })
    if (result.success) {
      getUser()
    } else {
      //display error
    }
  }

  const handleRevertPreviousStatus = async () => {
    if (window.confirm(`Please confirm you would like to revert to the previous vote by mail status.`)) {
      const result = await AdminVoterService.revertVoteByMailBallotStatus(user._id)
      if (result.success) {
        getUser()
      } else {
        alert('An error occurred.')
      }
    }
  }

  const getVoteByMailAction = () => {
    switch (user.voteByMailStatus) {
      case 'Approved':
        if (user.voted && user.votingChannel !== 'mail') {
          return null
        }
        if (user.onlineVoter?.voterInfo?.status === 'Approved')
          return (
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => handleUpdateMailBallotStatus('Printed')}
              text={t('Print Ballot Package')}
            />
          )
        break
      case 'Printed':
        if (user.voted && user.votingChannel !== 'mail') {
          return (
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => handleUpdateMailBallotStatus('Rejected')}
              text={t('Mark as Rejected')}
            />
          )
        }
        return <NVButton variant={'action'} height={50} onClick={() => handleUpdateMailBallotStatus('Ready')} text={t('Mark as Ready')} />
      case 'Ready':
        if (user.voted && user.votingChannel !== 'mail') {
          return (
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => handleUpdateMailBallotStatus('Rejected')}
              text={t('Mark as Rejected')}
            />
          )
        }
        return (
          <>
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => handleUpdateMailBallotStatus('Received')}
              text={t('Mark as Received')}
            />
          </>
        )
      case 'Received':
        if (user.voted && user.votingChannel !== 'mail') {
          return (
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => handleUpdateMailBallotStatus('ReceivedIssue')}
              text={t('Mark as Received with Issue')}
            />
          )
        }
        return (
          <>
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => {
                setDisplayedVotingChannelStrikeOff('mail')
                openStrikeOffVoterModal()
              }}
              text={t('Mark as Validated and Strike-Off Voter')}
            />
            <br />
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => handleUpdateMailBallotStatus('ReceivedIssue')}
              text={t('Mark as Received with Issue')}
            />
          </>
        )
      case 'ReceivedIssue':
        if (user.voted && user.votingChannel !== 'mail') {
          return (
            <NVButton variant={'action'} height={50} onClick={() => handleUpdateMailBallotStatus('Rejected')} text={t('Reject Ballot')} />
          )
        }
        return (
          <>
            <NVButton
              variant={'action'}
              height={50}
              onClick={() => {
                setDisplayedVotingChannelStrikeOff('mail')
                openStrikeOffVoterModal()
              }}
              text={t('Mark as Validated and Strike-Off Voter')}
            />
            <br />
            <NVButton variant={'action'} height={50} onClick={() => handleUpdateMailBallotStatus('Rejected')} text={t('Reject Ballot')} />
          </>
        )

      default:
        return null
    }
  }
  if (loading) return <Loader />
  else if (!user)
    return (
      <div className={styles['container']}>
        <div className={styles['header']}>
          <BackBtn />
        </div>
        <div className={styles['details']}>{t('admin.users.noUser')}</div>
      </div>
    )
  return (
    <>
      <RemoveEligibleElectorModal>
        <RemoveEligibleElector confirm={handleRemoveEligibleElector} />
      </RemoveEligibleElectorModal>
      <RemoveEligibleElectorFailedModal>
        <NVBasicModal
          title={t('admin.electorsList.eligible.removeEligible')}
          text={t('admin.electorsList.errors.removeElectorFailed')}
          error={true}
        />
      </RemoveEligibleElectorFailedModal>
      <EditUserModal>
        <EditUser modalView={editUserModalView} userToEdit={user?.onlineVoter} onUpdate={() => getUser()} />
      </EditUserModal>
      <StrikeOffVoterModal>
        <StrikeOffVoter
          registeredVotingChannel={displayedVotingChannelStrikeOff}
          confirm={handleStrikeOffEligibleElector}
          name={user?.fullName}
          votingDistricts={user.onlineVoter ? user.onlineVoter.district?.split(',').sort() : user.district?.split(',').sort()}
          displayedVotingChannel={displayedVotingChannelStrikeOff}
        />
      </StrikeOffVoterModal>
      <StrikeOffFailedModal>
        <NVBasicModal title={t('buttons.strikeOff')} text={t('admin.electorsList.errors.strikeOffFailed')} error={true} />
      </StrikeOffFailedModal>
      <ReverseStrikeOffVoterModal>
        <ReverseStrikeOffVoter
          confirm={handleReverseStrikeOffEligibleElector}
          name={user?.fullName}
          votingDistricts={user.onlineVoter ? user.onlineVoter.district?.split(',').sort() : user.district?.split(',').sort()}
        />
      </ReverseStrikeOffVoterModal>
      <ReverseStrikeOffFailedModal>
        <NVBasicModal title={t('buttons.reverseStrikeOff')} text={t('admin.electorsList.errors.reverseStrikeOffFailed')} error={true} />
      </ReverseStrikeOffFailedModal>
      <UpdateBallotStatusModal>
        {downloading ? (
          <Loader />
        ) : (
          <NVBasicModal
            title={t('admin.electorsList.vbmBallot')}
            text={updateBallotStatusModalText}
            buttonText='Confirm'
            onClickOk={onClickOkUpdateBallot}
          />
        )}
      </UpdateBallotStatusModal>

      <NoteModal>
        <Note confirm={updateNotes} initialNote={user.notes} />
      </NoteModal>

      <div className={styles['container']}>
        <div className={styles['header']}>
          <BackBtn />
          <h2>
            {t('admin.electorsList.voterId')} : {user?.electorId}
          </h2>
        </div>

        <div className={styles['details']}>
          <>
            <div className={styles['details__section']}>
              <div className={styles['details__names']}>
                <div className={styles['details__name']}>
                  <div className={styles['details__label']}>{t('form.labels.name')}</div>
                  <div className={styles['details__text']}>{user.fullName}</div>
                </div>
                <div className={styles['details__name']}>
                  <div className={styles['details__label']}>{t('form.labels.dateOfBirth')}</div>
                  <div className={styles['details__text']}>{user.dateOfBirth}</div>
                </div>
              </div>
              <div className={styles['status']}>
                {user.votingChannel && user.votingChannel.toLowerCase() !== 'n/a' && (
                  <span
                    className={clsx(
                      styles[`votingChannel-label`],
                      user.votingChannel ? styles[`votingChannel-label__${user.votingChannel}`] : '',
                    )}
                  >
                    {t(`admin.electorsList.votedChannelOptions.${user.votingChannel}`)}
                  </span>
                )}
                {getStatus(user) && (
                  <span className={clsx(styles['status-label'], [styles[`status-label__${getStatus(user)}`]])}>
                    {t(`admin.electorsList.eligibleVoterStatusOptions.${getStatus(user)}`)}
                  </span>
                )}
              </div>
            </div>

            <span className={styles['details__divider']}></span>

            <div className={styles['details__section']}>
              <div className={styles['details__names']}>
                <div className={styles['details__name']}>
                  <div className={styles['details__label']}>{t('form.labels.address')}</div>
                  <div className={styles['details__text']}>
                    {user.address?.fullAddress}
                    {user.address?.postalCode && !user.address?.fullAddress?.includes(user.address?.postalCode)
                      ? `, ${user.address?.postalCode}`
                      : ''}
                  </div>
                </div>
                {user.mailingAddress?.fullAddress &&
                  user.votingChannel === 'mail' &&
                  (KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin()) && (
                    <div className={styles['details__name']}>
                      <div className={styles['details__label']}>{t('form.labels.mailingAddress')}</div>
                      <div className={styles['details__text']}>
                        {user.mailingAddress?.fullAddress}
                        {user.mailingAddress?.postalCode && !user.mailingAddress?.fullAddress?.includes(user.mailingAddress?.postalCode)
                          ? `, ${user.mailingAddress?.postalCode}`
                          : ''}
                      </div>
                    </div>
                  )}
                <div className={styles['details__name']}>
                  <div className={styles['details__label']}>{t('admin.electorsDetails.eligibleVotingDistricts')}</div>
                  {(user.districts?.length || user.address?.districts?.length) && user.address?.ward ? (
                    <div className={styles['details__text']}>
                      {user.districts?.length
                        ? user.districts.map((d) => (d.ward ? `${d.wardType === 'VSD' ? `${d.wardType}-${d.ward}` : ''}` : '')).join('')
                        : user.address?.districts.length
                        ? user.address?.districts
                            .map((d) => (d.ward ? `${d.wardType === 'VSD' ? `${d.wardType}-${d.ward}` : ''}` : ''))
                            .join('')
                        : 'N/A'}
                      <br />
                      {user.schooBoards?.CBE ? `CBE - Calgary City Wards ${user.schooBoards.CBE}` : 'CBE - Not Eligible'}
                      <br />
                      {user.schooBoards?.CCSD ? `CCSD - Calgary City Wards ${user.schooBoards.CCSD}` : 'CCSD - Not Eligible'}
                    </div>
                  ) : KeycloakAdminService.isVBMAdmin() ||
                    KeycloakAdminService.isSuperAdmin() ||
                    KeycloakAdminService.isMonitoringAdmin() ? (
                    <NVButton
                      variant='text'
                      text='Check Where Do I Vote App then Add Voting Subdivision'
                      onClick={() => navigate(`/admin/elector-edit/${voterId}`)}
                    />
                  ) : (
                    <span>
                      <strong>Please check this address in the Where Do I Vote App</strong>
                    </span>
                  )}
                </div>
              </div>
            </div>

            {includeKnownIdNumber && (
              <>
                <span className={styles['details__divider']}></span>
                <div className={styles['details__section']}>
                  <div className={styles['details__name']}>
                    <>
                      <div className={styles['details__label']}>{t('registration.driversLicenseNumber')}</div>
                      <div className={styles['details__text']}>{user.knownIdNumber || user.onlineVoter?.voterInfo?.knownIdNumber}</div>
                    </>
                  </div>
                </div>
              </>
            )}

            {/* Linked registration */}
            {(KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin() || KeycloakAdminService.isMonitoringAdmin()) &&
              user.onlineVoter && (
                <>
                  <ConfirmUnlockAdminModal>
                    <ConfirmUnlockAdmin selectedUser={user.onlineVoter} fetchUsers={getUser} voter />
                  </ConfirmUnlockAdminModal>
                  <RegistartionDetails
                    user={user}
                    setEditUserModalView={setEditUserModalView}
                    openEditUserModal={openEditUserModal}
                    openConfirmUnlockAdminModal={openConfirmUnlockAdminModal}
                    getUser={getUser}
                  />
                </>
              )}
            {KeycloakAdminService.isContactInfoRoleAdmin() && (user.phone || user.onlineVoter?.phone) ? (
              <div className={styles['details__name']}>
                <div className={styles['details__label']}>{t('form.labels.phone')}</div>
                <div className={styles['details__text']}>{user.onlineVoter?.phone || user.phone}</div>
              </div>
            ) : null}

            {!user.removed &&
              (KeycloakAdminService.isSuperAdmin() ||
                KeycloakAdminService.isContactInfoRoleAdmin() ||
                KeycloakAdminService.isMonitoringAdmin() ||
                KeycloakAdminService.isVBMAdmin()) && (
                <>
                  <span className={styles['details__divider']}></span>
                  <div className={styles['details__actions']}>
                    {KeycloakAdminService.isSuperAdmin() ? (
                      <NVButton
                        variant={'primary'}
                        height={50}
                        onClick={() => openRemoveEligibleElectorModal()}
                        text={t('buttons.remove')}
                      />
                    ) : null}
                    <NVButton
                      variant={'action'}
                      height={50}
                      onClick={() =>
                        navigate(`/admin/elector-edit/${voterId}?pageState=${btoa(window.location.pathname + window.location.search)}`)
                      }
                      text={t('buttons.edit')}
                    />
                  </div>
                </>
              )}
          </>
          {!user.removed &&
            (KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin()) &&
            user.registered &&
            (user.votingChannel === 'mail' || user.voteByMailStatus) && (
              <div>
                <span className={styles['registration-header']}>{t('Mail-In Ballot Management')}</span>
                <div className={styles['details__section']}>
                  <div className={styles['details__name']}>
                    <div className={styles['details__label']}>{t('Ballot Package Status')}</div>
                    <div className={styles['details__text']}>
                      {user.voteByMailStatus ? user.voteByMailStatus : user.onlineVoter?.voterInfo?.status}
                    </div>
                  </div>
                  <div className={styles['details__name']}>
                    <div className={styles['details__label']}>{t('Ballot Delivery')}</div>
                    <div className={styles['details__text']}>
                      {' '}
                      {user.onlineVoter?.voterInfo.voteByMailPickup ? 'Pick Up' : 'Delivery by Mail'}
                    </div>
                  </div>

                  <div>
                    {user.voteByMailStatus !== 'Approved' && (
                      <div className={styles['details__name']}>
                        <NVButton
                          variant={'primary'}
                          height={50}
                          onClick={handleRevertPreviousStatus}
                          text={t('Revert to Previous Status')}
                        />
                      </div>
                    )}
                    {user.votingChannel === 'mail' && <div className={styles['details__name']}>{getVoteByMailAction()}</div>}
                  </div>
                </div>
                <div>
                  <span className={styles['registration-header']}>{t('Ballot Package Status History')}</span>
                  <div className={styles['details__name']}>
                    {user.vbmStatusUpdates.map((s, i) => (
                      <div key={i}>
                        {s.user.username} updated the status from {s.previousStatus} to {s.newStatus} on{' '}
                        {formatDateLocale(s.date, currentLanguage)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

          {(KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin()) && (
            <div>
              <span className={styles['registration-header']}>{t('Notes')}</span>
              <div className={styles['details__name']}>
                <div className={styles['details__section']}>{user.notes}</div>
              </div>
              <div className={styles['details__actions']}>
                <NVButton
                  variant={'primary'}
                  height={50}
                  onClick={() => {
                    openNoteModal()
                  }}
                  text={t('Add/Edit Notes')}
                />
              </div>
            </div>
          )}
          {!user.removed && KeycloakAdminService.hasAnyOfRoles(adminRolesPerAction.strikeOffEnabled) && strikeOffButtonEnabled && (
            <>
              {/* <span className={styles['details__divider']}></span> */}
              <div className={styles['details__actions']}>
                {KeycloakAdminService.isSuperAdmin() && user.voted && user.votingChannel === 'inPerson' ? (
                  <NVButton
                    variant={'primary'}
                    height={50}
                    onClick={() => openReverseStrikeOffVoterModal()}
                    text={t('buttons.reverseStrikeOff')}
                  />
                ) : null}
                {!user.voted &&
                // if strike off is not limited to specific voting channels
                // or if strike off is limited to specific voting channels and the user is registered for that voting channel
                (KeycloakAdminService.isSuperAdmin() ||
                  KeycloakAdminService.isContactInfoRoleAdmin() ||
                  KeycloakAdminService.isVBMAdmin() ||
                  KeycloakAdminService.isMonitoringAdmin()) &&
                (!displayStrikeOffOnlyVotingChannels?.length || displayStrikeOffOnlyVotingChannels.includes(user.votingChannel)) &&
                !loading ? (
                  <NVButton
                    variant={'action'}
                    height={50}
                    onClick={() => {
                      setDisplayedVotingChannelStrikeOff('inPerson')
                      openStrikeOffVoterModal()
                    }}
                    text={KeycloakAdminService.isSuperAdmin() ? t('Strike-Off (in Person)') : t('buttons.strikeOff')}
                  />
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}
